import { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SmoMoon } from '../../../../../Models/Smo/SmoMoon';
import UserRunSelectors from '../../../../../Modules/Redux/Global/UserRun/UserRunSelectors';
import MoonListActions from '../../../../../Modules/Redux/Pages/MoonList/MoonListActions';
import { Optional } from '../../../../../Utils/Types';
import { Grid } from '../../../Components/Grid/Grid';
import { MoonCell } from '../../../Components/MoonCell/MoonCell';
import { PageLayout } from '../../../Components/PageLayout/PageLayout';
import { RunSection } from '../../../Components/RunSection/RunSection';
import { TabBar } from '../../../Components/TabBar/TabBar';
import { TabItem } from '../../../Components/TabItem/TabItem';
import { StreamPageRunProps } from './StreamPageRunProps';

export const StreamPageRun: FunctionComponent<StreamPageRunProps> = ({ run }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const nextMoon: Optional<SmoMoon> = useSelector(UserRunSelectors.nextMoon);
  const remainingMoons: SmoMoon[] = useSelector(UserRunSelectors.remainingMoons);
  const collectedMoons: SmoMoon[] = useSelector(UserRunSelectors.collectedMoons);

  function newRun(): void {
    navigate('/moon/list');
  }

  function restartRun(): void {
    dispatch(MoonListActions.startRunWithMoonListId(run.moonList.id));
  }

  return (
    <div>
      <div className="py-4 mb-6">
        <PageLayout>
          <div className="justify-between h-stack">
            <div className="items-center justify-between h-stack">
              <div>
                <h2 className="large-title">{run.moonList.name}</h2>
                <div className="space-x-1 text-sm h-stack">
                  <h3 className="text-text-secondary">by</h3>
                  <h3>{run.moonList.author.login}</h3>
                </div>
              </div>
            </div>

            <TabBar>
              <TabItem title="Restart" icon="/images/icons/restart_red.svg" onClick={restartRun} />
              <TabItem title="Change list" icon="/images/icons/moon_red.svg" onClick={newRun} />
            </TabBar>
          </div>
        </PageLayout>
      </div>

      <PageLayout>
        <div className="items-stretch space-x-4 h-stack">
          <div className="w-full">
            {nextMoon ? (
              <RunSection title="Next">
                <Grid className="flex-1" fillStyle="auto-fill">
                  <MoonCell moon={nextMoon} style="dashed-highlighted" />
                </Grid>
              </RunSection>
            ) : undefined}

            {remainingMoons.length > 0 ? (
              <RunSection title="Remaining">
                <Grid className="flex-1" fillStyle="auto-fill">
                  {remainingMoons.map((moon) => (
                    <MoonCell key={moon.id} moon={moon} style="dashed" />
                  ))}
                </Grid>
              </RunSection>
            ) : undefined}

            {collectedMoons.length > 0 ? (
              <RunSection title="Collected">
                <Grid className="flex-1" fillStyle="auto-fill">
                  {collectedMoons.map((moon) => (
                    <MoonCell key={moon.id} moon={moon} />
                  ))}
                </Grid>
              </RunSection>
            ) : undefined}
          </div>
        </div>
      </PageLayout>
    </div>
  );
};
